import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { cn } from "@/lib/utils";

export function SlotPicker({ date, value, onChange, publicMode = true, testId = "slot-picker" }) {
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!date) return;
    setLoading(true);
    const url = publicMode ? `/public/slots?date=${date}` : `/bookings/slots?date=${date}`;
    api.get(url).then((r) => setSlots(publicMode ? r.data.slots : r.data)).catch(() => setSlots([])).finally(() => setLoading(false));
  }, [date, publicMode]);
  useEffect(() => { if (value !== null && value !== undefined && slots.length && slots.find((s) => s.hour === value)?.full) onChange(null); }, [slots]); // eslint-disable-line
  if (!date) return null;
  return (
    <div data-testid={testId}>
      <div className="flex justify-between items-center mb-1.5"><span className="text-xs text-zinc-400 uppercase tracking-wider">Jam kedatangan</span>{loading && <span className="text-[11px] text-zinc-500">memuat…</span>}</div>
      <div className="grid grid-cols-3 sm:grid-cols-5 gap-1.5">
        {slots.map((s) => (
          <button key={s.hour} type="button" disabled={s.full} onClick={() => onChange(value === s.hour ? null : s.hour)} data-testid={`${testId}-${s.hour}`}
            className={cn("rounded border px-2 py-2 text-sm font-mono transition-colors", s.full ? "border-zinc-800 text-zinc-600 line-through cursor-not-allowed" : value === s.hour ? "bg-red-600 border-red-600 text-white" : "border-zinc-700 text-zinc-300 hover:border-red-600")}>
            {s.label}<div className={cn("text-[10px] font-sans", s.full ? "text-zinc-700" : value === s.hour ? "text-red-100" : "text-zinc-500")}>{s.past ? "lewat" : s.full ? "penuh" : `${s.available} slot`}</div>
          </button>))}
      </div>
      <p className="text-[11px] text-zinc-500 mt-1.5">{value !== null && value !== undefined ? `Dipilih ${String(value).padStart(2, "0")}:00` : "Kosongkan untuk dipilihkan jam paling lega."}</p>
    </div>
  );
}
